import { gql } from '@apollo/client'

export enum AggregationInterval {
  Hourly = 'HOURLY',
  Daily = 'DAILY'
}

export const AGGREGATED_UNISWAP_PRICE_QUERY = gql`
  query ($address: String, $interval: String) {
    aggregatedUniswapPriceEntities(
      first: 168
      where: { address: $address, interval: $interval }
      orderBy: openTimestamp
      orderDirection: desc
    ) {
      id
      address
      interval
      openPrice
      closePrice
      openTimestamp
      closeTimestamp
    }
  }
`

export const AGGREGATED_STRATEGY_PRICE_QUERY = gql`
  query ($address: String, $strategyId: Int, $interval: String, $first: Int) {
    aggregatedUniswapPriceEntities(
      first: $first
      where: { address: $address, strategyId: $strategyId, interval: $interval }
      orderBy: openTimestamp
      orderDirection: desc
    ) {
      id
      address
      strategyId
      interval
      openPrice
      closePrice
      openTimestamp
      closeTimestamp
    }
  }
`

export type AggregatedUniswapPriceEntities = {
  aggregatedUniswapPriceEntities: {
    id: string
    address: string
    strategyId: string
    interval: string
    openPrice: string
    closePrice: string
    openTimestamp: string
    closeTimestamp: string
  }[]
}
